import { render, staticRenderFns } from "./View-details.vue?vue&type=template&id=14c43dcc&scoped=true&"
import script from "./View-details.vue?vue&type=script&lang=js&"
export * from "./View-details.vue?vue&type=script&lang=js&"
import style0 from "./View-details.vue?vue&type=style&index=0&id=14c43dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c43dcc",
  null
  
)

export default component.exports